"use strict";

exports.__esModule = true;
exports.getTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _tooltipStyles = require("../../common/styles/tooltipStyles");
var _Utils = require("../../../../Utils");
var _reactIntl = require("react-intl");
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getTooltip = exports.getTooltip = function getTooltip(activityDetails, devices, tooltipSort) {
  if (tooltipSort === void 0) {
    tooltipSort = _utils.TOOLTIP_SORT_DESC;
  }
  return function (item) {
    var activities = (0, _utils.sortTooltipActivities)(item.value, activityDetails, tooltipSort);
    return /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipTable, {
      "data-testid": "ActivitiesChart.Tooltip"
    }, (devices == null ? void 0 : devices.length) > 1 && /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipRow, {
      "data-testid": "ActivitiesChart.Tooltip.header"
    }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "left",
      width: 15
    }), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "left",
      width: 130
    }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TextValue, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "Tooltip.totalOfDevices",
      defaultMessage: "Total devices selected"
    }))), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "right",
      width: 30
    }), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "right",
      width: 70
    }), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "right",
      width: 15
    }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
      bold: true
    }, "" + devices.length.toFixed(0))))), /*#__PURE__*/_react["default"].createElement("tbody", null, activities.map(function (activity) {
      var activityData = activityDetails.find(function (v) {
        return v.key === activity.key;
      });
      return /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipRow, {
        key: activity.key,
        "data-testid": "ActivitiesChart.Tooltip.row." + activity.key
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "left",
        width: 15
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.ColorBlock, {
        color: activityData && activityData.color
      })), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "left",
        width: 130
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TextValue, null, activityData && activityData.name)), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "right",
        width: 30
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
        bold: true
      }, (activity.value || 0).toFixed(2) + "%")), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "right",
        width: 70
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
        bold: true
      }, (0, _Utils.formatDuration)(activity.duration || 0))), (devices == null ? void 0 : devices.length) > 1 && /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "right",
        width: 15
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
        bold: true
      }, "" + activity.devices.length.toFixed(0))));
    })));
  };
};